import { Component, For } from "solid-js";

const PLACEHOLDER_TILES = [
  { id: "placeholder-1", month: "Month 1", subtext: "$-.--" },
  { id: "placeholder-2", month: "Month 2", subtext: "$-.--" },
  { id: "placeholder-3", month: "Month 3", subtext: "$-.--" },
  { id: "placeholder-4", month: "Month 4", subtext: "$-.--" },
  { id: "placeholder-5", month: "Month 5", subtext: "$-.--" },
  { id: "placeholder-6", month: "Month 6", subtext: "$-.--" },
  { id: "placeholder-1", month: "Month 7", subtext: "$-.--" },
  { id: "placeholder-2", month: "Month 8", subtext: "$-.--" },
  { id: "placeholder-3", month: "Month 9", subtext: "$-.--" },
  { id: "placeholder-4", month: "Month 10", subtext: "$-.--" },
  { id: "placeholder-5", month: "Month 11", subtext: "$-.--" },
  { id: "placeholder-6", month: "Month 12", subtext: "$-.--" },
];

/**
 * Dummy Component for when campaign data is not available
 */

const CampaignSelectionPlaceholder: Component = () => {
  return (
    <div class="flex flex-col gap-FsSpacing1x">
      <fd-mfe-choice-button-group prop:columns={3}>
        <For each={PLACEHOLDER_TILES}>
          {(tile) => (
            <fd-mfe-choice-button
              prop:labelText={tile.month}
              prop:subtext={tile.subtext}
              prop:selected={false}
              prop:type="checkbox"
              prop:size="medium"
              prop:value={tile.id}
              class="min-h-FsSizing9x @xs:min-h-FsSizing16x"
            />
          )}
        </For>
      </fd-mfe-choice-button-group>
    </div>
  );
};

export default CampaignSelectionPlaceholder;
